<template>
  <div class="w3-main main-container">

    <page-header />

    <div class="w3-container about-container">
      <h1 class="w3-xxxlarge"><b>{{ $t('Items') }}</b></h1>

      <hr class="w3-round">

      <div class="items-images-container">
        <div
          class="items-images-thumbnail"
          v-for="item in items"
        >
          <div class="item-category-name-layer">
            <router-link :to="`/termekeink/${item._id}`">
              {{ item.title[locale] }}
            </router-link>
          </div>

          <img
            :src="`static/images/items/thumbnails/${item.thumbnail}`"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<i18n>
  {
    "de": {
      "Items": "Unsere Produkte"
    },
    "en": {
      "Items": "Our products"
    },
    "hu": {
      "Items": "Termékeink"
    }
  }
</i18n>

<script>
  import PageHeader from '@/components/PageHeader';
  import items from 'static/data/items.json';

  export default {
    name: 'items',
    data() {
      return {
        items,
      };
    },
    created() {
      document.title = 'Termékeink | BeCreative';
    },
    mounted() {
      scrollTo(0, 0);
    },
    computed: {
      locale() {
        return this.$store.state.i18n.locale;
      },
    },
    components: {
      PageHeader,
    },
  };

</script>

<style scoped>
  hr {
    width: 50px;
    border: 5px solid;
    color: #eb2e4a !important;
    margin-top: 0px;
  }

  .about-container {
    margin-top: 75px;
    max-width: 1000px;
  }

  .items-images-container {
    max-width: 1000px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    cursor: pointer;
  }

  .items-images-thumbnail {
    position: relative;
    margin: 5px;
    width: 31%;
  }

  .items-images-container img {
    width: 100%;
  }

  @media (max-width: 1100px) {
    .items-images-container {
      justify-content: center;
    }

    .items-images-container div {
      width: 100%;
      max-width: 512px;
      margin: 0;
    }
  }

  .item-category-name-layer {
    position: absolute !important;
    margin: 0 !important;
    height: 100%;
    width: 101%;
    background: rgba(255, 255, 255, 0.7);
    display: table;
  }

  .item-category-name-layer:hover {
    opacity: 0;
  }

  .item-category-name-layer a {
    width: 100%;
    word-spacing: 100vw;
    margin: 0;
    text-align: center;
    font-weight: 600;
    color: #eb2e4a !important;
    line-height: 1.2;
    display: table-cell;
    vertical-align: middle;
    text-decoration: none;
    font-size: 24px;
  }

</style>



// WEBPACK FOOTER //
// Items.vue?4915bc69